import type { Ref } from '@wix/thunderbolt-types'
import type { GhostPropertiesItem } from '@wix/thunderbolt-becky-root'
import { MOBILE_PROPERTY_SUFFIX } from '../../../constants'
import { isGhostPropertyItem } from '../../../byRefUtils'
import { getDataItemRefsWithOverrides, resolveOverrideItem } from '../../dataConsumption'
import type { PropertyItemWithOverrideRefs } from '../../types'
import type { DependenciesData } from './types'
import { createConsumptionDataNode } from './utils/dataNodeUtils'

type Dependencies = {
	desktopItemWithOverrides: Array<Ref<GhostPropertiesItem>>
	mobileItemWithOverrides: false | Array<Ref<GhostPropertiesItem>>
}

export const Properties = createConsumptionDataNode<DependenciesData, Dependencies, PropertyItemWithOverrideRefs>({
	getDependencies: ({
		isMobileView,
		queryName,
		templateComponent,
		getOverrideDataRefs,
		createRefInTemplateNamespace,
	}) => ({
		desktopItemWithOverrides: getDataItemRefsWithOverrides({
			templateComponent,
			queryName,
			getOverrideDataRefs,
			createRefInTemplateNamespace,
		}) as Array<Ref<GhostPropertiesItem>>,
		mobileItemWithOverrides:
			isMobileView &&
			(getDataItemRefsWithOverrides({
				templateComponent,
				queryName,
				itemSuffix: MOBILE_PROPERTY_SUFFIX,
				getOverrideDataRefs,
				createRefInTemplateNamespace,
			}) as Array<Ref<GhostPropertiesItem>>),
	}),
	toViewItem: ({ id, value: { desktopItemWithOverrides, mobileItemWithOverrides } }) => {
		const desktopPropItem = resolveOverrideItem(desktopItemWithOverrides, id)
		if (!mobileItemWithOverrides) {
			// we only create the mobile prop items array in mobile view
			return desktopPropItem
		}

		const isGhostInDesktop = isGhostPropertyItem(desktopPropItem as GhostPropertiesItem)
		const mobilePropItem = mobileItemWithOverrides.find(Boolean)

		// in mobile view, `id` is the propItem's inflated *mobile* id (with '-mobile' suffix)
		return isGhostInDesktop || !mobilePropItem
			? {
					...desktopPropItem,
					id,
			  }
			: resolveOverrideItem(mobileItemWithOverrides, id)
	},
})
